<template>
  <div class="q-edit-content">

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {
    check () {
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.q-edit-content {
}
</style>
